import { useTranslation } from "react-i18next";
import { Outlet, useLocation } from "react-router-dom";
import BookInf from "./bkInf/web";
import {
  BookInfProvider,
  useBookInfContext,
} from "components/context/bookInfContext";
import BottomSheet from "./bkInf/bottomSheet";
// import BottomBookInf from "page/sample/book/bookInf";
import "./book.scss";
// import SamPleBookInf from "../sample/book/bookInf";
import { useAuthContext } from "components/context/authContext";
import { useEffect } from "react";

const BookMenu = () => {
  const { t } = useTranslation();

  const { bkStep } = useBookInfContext();

  return (
    <aside>
      <div className="book sub-header">
        <div className="w-full flex justify-around md:start-center md:gap-x-[60px]">
          <h4 className={bkStep === 1 ? "on" : ""}>
            <span>{"Step1."}</span>
            <span>{t("sb_ttl_bk_rm")}</span>
          </h4>
          <h4 className={bkStep === 2 ? "on" : ""}>
            <span>{"Step2."}</span>
            <span>{t("sb_ttl_bk_op")}</span>
          </h4>
          <h4 className={bkStep === 3 ? "on" : ""}>
            <span>{"Step3."}</span>
            <span>{t("sb_ttl_bk_inf")}</span>
          </h4>
          <h4 className={bkStep === 4 ? "on" : ""}>
            <span>{"Step4."}</span>
            <span>{t("sb_ttl_bk_cmplt")}</span>
          </h4>
          <div>
            <a href="">{t("lnk_go_htl_bk")}</a>
          </div>
        </div>
      </div>
    </aside>
  );
};

const BookInfPage = () => {
  const { pathname } = useLocation();
  const { viewPort } = useAuthContext();
  const { bkStep } = useBookInfContext();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [bkStep]);

  return (
    <div className="w-full flex gap-10 ">
      <Outlet />
      {!pathname.includes("sample") && <BookInf />}
      {!pathname.includes("sample") && viewPort?.screen === "mb" && (
        <BottomSheet />
      )}

      {/* {pathname.includes("sample") && bkStep < 3 && <SamPleBookInf />} */}
    </div>
  );
};

export default function BookLayout() {
  const { pathname } = useLocation();

  return (
    <BookInfProvider>
      <div className="book">
        <BookMenu />
        <BookInfPage />
        {/* {pathname.includes("sample") && (
          <>
            <BottomBookInf />
          </>
        )} */}
      </div>
    </BookInfProvider>
  );
}
